<template>
  <div>
    <b-row class="mt-4">
      <b-col cols="12" sm="9">
        <b-form-checkbox v-model="checked"  switch>
          <div>
            <i :class="` ${icon} fs-18 mr-2`"></i>
            <strong> {{ namePermission }} </strong>
            <span>
              <i
                class="fas fa-question-circle question-tool-tips"
                :id="keyValue"
              ></i>
              <b-tooltip :target="keyValue">
                {{ description }}
              </b-tooltip>
            </span>
          </div>
        </b-form-checkbox>
        <p v-if="error"  class="mt-1 ml-2 text-red">
          Favor selecionar o tipo de permissão
        </p>
      </b-col>
      <b-col cols="12" sm="3" class="text-right mt-1">
        <b-form-radio-group
          v-model="selected"
          :options="options"
          button-variant="outline-primary"
          size="sm"
          buttons
          :disabled="!checked"
        ></b-form-radio-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'SelectPermissionComponent',

  props: {
    namePermission: {
      type: String,
      required: true,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    keyValue: {
      type: String,
      require: true,
      default: '',
    },
    selectPermission: {
      type: Number,
      require: true,
      default: 0,
    },
    checkPermission: {
      type: Boolean,
      require: true,
      default:false
    },
    error: {
      type: Boolean,
      require: true,
      default:false
    },
    icon: {
      type: String,
      required: true,
      default: '',
    },
  },

  data() {
    return {
      checked: false,
      selected: '',
      options: [
        { text: 'Só visualizar', value: 1 },
        { text: 'Total', value: 2 },
      ],
    };
  },

  watch: {
    'checked' : function(){
      this.isSelected();
    },

    'selected' : function(){
      this.isSelected();
    },
  },

  mounted(){
    this.checked =  this.checkPermission;
    this.selected = this.selectPermission;
  },

  methods: {
    isSelected(){
      this.$emit('permissionSelect', {
        selected: this.checked,
        value: this.selected,
        key: this.keyValue
      });
    },
  }
}
</script>

<style>
.textAlign{
  margin-right: -100px;
}
.text-red {
  color: red;
  font-size: 15px;
}
</style>